import { Component, Vue } from 'vue-property-decorator'
import HighFilter from '@/components/highFilter/index.vue'
import { TagsViewModule } from '@/store/modules/tags-view'
import { querypaperMaster, editpaperMaster, queryMentorDetail, edityMentorDetail, edittechnologyTADetail, querytechnologyTADetail, querySupervisorDetail, editSupervisorDetail, createMentor, createPaperMaster, createSupervisorTeacher, createTechnologyTATeacher, getBasicTeacherList } from '@/api'
import urlBase from '@/utils/urlBase'

@Component({ name: 'MainTutorDetail', components: { HighFilter } })
export default class MainTutorDetail extends Vue {
  private detailObj: any = {
    detail: '',
    resumeUrl: ''
  }

  private editType: any = ''
  private pageType: any = ''
  private teacherId: any = ''
  private optionsStatus: any = [{ val: 1, name: '是' }, { val: 0, name: '否' }]
  private loading: any =false
  private rules: any = {
    realName: [
      { required: true, message: '请输入姓名', trigger: 'blur' }
    ],
    nickName: [
      { required: true, message: '请输入昵称', trigger: 'blur' }
    ],
    status: [{ required: true, message: '请选择状态', trigger: 'blur' }],
    phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
    idCard: [{ required: true, message: '请输入证件号', trigger: 'blur' }]
  }

  private mentorRules: any = {
    realName: [
      { required: true, message: '请输入姓名', trigger: 'blur' }
    ],
    nickName: [
      { required: true, message: '请输入昵称', trigger: 'blur' }
    ],
    status: [{ required: true, message: '请选择状态', trigger: 'blur' }],
    phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
    idCard: [{ required: true, message: '请输入证件号', trigger: 'blur' }],
    gtdTeacherId: [{ required: true, message: '请选择导师库副导师', trigger: 'blur' }]
  }

  private workStatusList: any = [{ val: 1, name: '在职' }, { val: 2, name: '离职' }]
  private ruleForm: any = {}
  private paperMasterObj: any = {}
  private MentorrObj: any = {}
  private technologyTA: any = {}
  private Supervisor: any = {}
  private uploadUrl = {
    // technologyTACv: 'http://192.168.0.33:10069/upload/teacherCv/technologyTACv',
    // masterCv: 'http://192.168.0.33:10069/upload/teacherCv/masterCv',
    // paperMasterCv: 'http://192.168.0.33:10069/upload/teacherCv/paperMasterCv',
    // mentorCv: 'http://192.168.0.33:10069/upload/teacherCv/mentorCv',
    // supervisorCv: 'http://192.168.0.33:10069/upload/teacherCv/supervisorCv',
    // TACv: 'http://192.168.0.33:10069/upload/teacherCv/TACv'
    technologyTACv: urlBase.eduBaseUrl + 'upload/teacherCv/technologyTACv',
    masterCv: urlBase.eduBaseUrl + 'upload/teacherCv/masterCv',
    paperMasterCv: urlBase.eduBaseUrl + 'upload/teacherCv/paperMasterCv',
    mentorCv: urlBase.eduBaseUrl + 'upload/teacherCv/mentorCv',
    supervisorCv: urlBase.eduBaseUrl + 'upload/teacherCv/supervisorCv',
    TACv: urlBase.eduBaseUrl + 'upload/teacherCv/TACv'
  }

  private teacherSchoolList: any = []
  private loadingIndex: any = false

  created () {
    // editType 1.修改 2.查看 3.新增
    // pageType 老师类型 2.Mentor 3.论文导师 4.科研助教导师 5.Supervisor
    this.teacherId = this.$route.query.id ? this.$route.query.id : ''
    this.editType = this.$route.query.type
    this.pageType = this.$route.query.pageType
    this.initSchoolTeacherList('', 1)
  }

  get titleName () {
    let str = ''
    this.editType === 1 ? str = '编辑' : (this.editType === 2 ? str = '查看' : str = '新增')
    this.pageType === 2 ? str += 'Mentor' : (this.pageType === 3 ? str += '论文导师' : (this.pageType === 5 ? str += 'Supervisor' : str += '科研助教导师'))
    return str
  }

  private async save () {
    let flag = false
    let flag1 = true
    const obj: any = this.$refs.ruleForm
    obj.validate(async (valid: any) => {
      if (valid) {
      } else {
        flag1 = false
        return false
      }
    })
    if (!flag1) {
      return
    }
    // 修改导师详情
    if (this.editType === 1) {
      if (this.pageType === 3) { // 论文导师详情
        const { error }: any = await editpaperMaster(this.paperMasterObj)
        if (!error) {
          this.$message({ message: '保存成功', type: 'success' })
          flag = true
        }
      }
      if (this.pageType === 2) { // Mentor
        const { error }: any = await edityMentorDetail(this.MentorrObj)
        if (!error) {
          this.$message({ message: '保存成功', type: 'success' })
          flag = true
        }
      }
      if (this.pageType === 4) { // Mentor
        const { error }: any = await edittechnologyTADetail(this.technologyTA)
        if (!error) {
          this.$message({ message: '保存成功', type: 'success' })
          flag = true
        }
      }
      if (this.pageType === 5) {
        const { error }: any = await editSupervisorDetail(this.Supervisor)
        if (!error) {
          this.$message({ message: '保存成功', type: 'success' })
          flag = true
        }
      }
    } else if (this.editType === 3) { // 新增导师详情
      if (this.pageType === 3) { // 论文导师详情
        const { error }: any = await createPaperMaster(this.paperMasterObj)
        if (!error) {
          this.$message({ message: '新建成功', type: 'success' })
          flag = true
        }
      }
      if (this.pageType === 2) { // Mentor
        const { error }: any = await createMentor(this.MentorrObj)
        if (!error) {
          this.$message({ message: '新建成功', type: 'success' })
          flag = true
        }
      }
      if (this.pageType === 4) { // Mentor
        const { error }: any = await createTechnologyTATeacher(this.technologyTA)
        if (!error) {
          this.$message({ message: '新建成功', type: 'success' })
          flag = true
        }
      }
      if (this.pageType === 5) {
        const { error }: any = await createSupervisorTeacher(this.Supervisor)
        if (!error) {
          this.$message({ message: '新建成功', type: 'success' })
          flag = true
        }
      }
    }
    if (flag) {
      TagsViewModule.delView(this.$route)
      this.$router.go(-1)
    }
  }

  private async initDetail () {
    // 修改查看详情
    if (this.editType === 1 || this.editType === 2) {
      if (this.pageType === 3) { // 论文导师详情
        const result: any = await querypaperMaster({ id: this.teacherId })
        this.paperMasterObj = result
      }
      if (this.pageType === 2) { // Mentor详情
        const result: any = await queryMentorDetail({ id: this.teacherId })
        this.MentorrObj = result
        if (result.gtdTeacherId) {
          const obj = {
            id: result.gtdTeacherId,
            teacherIndex: result.gtdTeacherIndex,
            name: result.gtdTeacherName
          }
          const item = this.teacherSchoolList.find((v: any) => v.id === result.gtdTeacherId)
          if (!item) {
            this.teacherSchoolList.push(obj)
          }
        }
      }
      if (this.pageType === 4) { // 科研组教详情
        const result: any = await querytechnologyTADetail({ id: this.teacherId })
        this.technologyTA = result
      }
      if (this.pageType === 5) { // Supervisor详情
        const result: any = await querySupervisorDetail({ id: this.teacherId })
        this.Supervisor = result
      }
    } else { // 新增初始化数据
    }
  }

  // 简历上传回调函数
  private handleResumeSuccess (obj: any, res: any) {
    this.$set(obj, 'resumeUrl', res.data.url)
    this.$message({ message: '上传简历成功', type: 'success' })
    this.loading.close()
  }

  // 上传中提示
  private handleApplicationFormProgress () {
    this.loading = this.$loading({
      lock: true,
      text: '上传中...',
      spinner: 'el-icon-loading'
    })
  }

  // 上传失败回调函数
  private handleApplicationFormError () {
    this.$message({ message: '上传失败，请重新上传', type: 'error' })
    this.loading.close()
  }

  // 查看课表
  async lookRow (row: any) {
    if (this.pageType === 3) {
      // 论文导师查看课表详情
      this.$router.push({ path: 'tutor_timetable', query: { teacherId: this.teacherId, teacherName: this.paperMasterObj.realName } })
    } else {
      let type: any = null
      let name: any = null
      if (this.pageType === 2) {
        type = 4 // mentor跳转到查看课表页的类型
        name = this.MentorrObj.realName
      }
      if (this.pageType === 4) {
        type = 5 // 科研助教导师跳转到查看课表页的类型
        name = this.technologyTA.realName
      }
      if (this.pageType === 5) {
        type = 6 // Supervisor跳转到查看课表页的类型
        name = this.Supervisor.realName
      }
      this.$router.push({ path: '/student/schedule', query: { teacherId: this.teacherId, teacherName: name, lookType: type } })
    }
  }

  async initSchoolTeacherList (query: any, type: any) {
    const data = await getBasicTeacherList(query)
    this.teacherSchoolList = data
    if (type) {
      await this.initDetail()
    }
  }

  async remoteMethod (query: any) {
    if (query !== '') {
      this.loadingIndex = true
      setTimeout(async () => {
        await this.initSchoolTeacherList(query, 0)
        this.loadingIndex = false
      }, 200)
    } else {
      await this.initSchoolTeacherList('', 0)
    }
  }

  teacherChange (val: any) {
    if (this.editType === 3) { // 新增
      const obj = this.teacherSchoolList.find((item: any) => item.id === val)
      if (obj) {
        this.$set(this.MentorrObj, 'realName', obj.name)
        this.$set(this.MentorrObj, 'school', obj.school)
        this.$set(this.MentorrObj, 'nationality', obj.country)
        this.$set(this.MentorrObj, 'phone', obj.phone)
        this.$set(this.MentorrObj, 'email', obj.email)
        this.$set(this.MentorrObj, 'resumeUrl', obj.teacherResume)
      } else {
        this.$nextTick(() => {
          if (this.$refs.mySelect) {
            // this.$refs.mySelect.blur()
          }
        })
      }
    }
  }
}
